<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-3">
      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Tutor</h3>
          <input
            v-model="conditions.tutor"
            type="text"
            class="form-control w-25"
          >
        </b-col>
      </b-form-row>
      <h3 class="common__search-title">Lesson Date</h3>
      <b-form-row class="mb-4">
        <b-col>
          <div>from</div>
          <DateInput v-model="conditions.lessonDateFrom" />
        </b-col>
        <b-col>
          <div>to</div>
          <DateInput v-model="conditions.lessonDateTo" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Level</h3>
          <LevelsInput v-model="conditions.levels"/>
        </b-col>
      </b-form-row>
      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Period</h3>
          <PeriodInput v-model="conditions.periods"/>
        </b-col>
      </b-form-row>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang='ts'>
import Vue from 'vue'
import _ from 'lodash';
import LevelsInput from '@/components/parts/inputItem/LevelsInput.vue';
import DateInput from '@/components/parts/inputItem/DateInput.vue';
import { DeadlineConditions, DeadlineType, DeadlineTypeCode } from '@/store/deadlines/types'
import PeriodInput from '@/components/parts/inputItem/PeriodsInput.vue';

// 検索の初期設定値
const initialConditions: DeadlineConditions = {
  tutor: null,
  lessonDateFrom: null,
  lessonDateTo: null,
  levels: [],
  periods: [],
  types: [DeadlineType.preparation as DeadlineTypeCode],
}

export default Vue.extend({
  data() {
    return {
      conditions: _.cloneDeep(initialConditions),
    };
  },

  components: {
    LevelsInput,
    DateInput,
    PeriodInput,
  },

  methods: {
    search() {
      // 検索ボタン押した場合
      this.$emit('search', this.conditions)
    },
    reset() {
      // リセットボタン押した場合
      this.conditions = _.cloneDeep(initialConditions);
      this.search();
    },
  },
  created() {
    this.search();
  },
});

</script>
